import { render, staticRenderFns } from "./DeliveryTab.vue?vue&type=template&id=7e90e1d0&scoped=true&"
import script from "./DeliveryTab.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTab.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTab.vue?vue&type=style&index=0&id=7e90e1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90e1d0",
  null
  
)

export default component.exports